<template>
  <div class="rate-details">
    <span>{{ details.nights }}</span>
    <span>{{ details.occupancy }}</span>
    <span v-if="!points_available" class="semibold">€ {{ details.price_nightly }} per notte</span>
    <sale-scenario :sale="details.sale_scenario" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { deep_clone } from "@src/utilities"
import { markup, get_total_nights, get_label_occupancy } from '@liveeps/utilities'
import SaleScenario from "@liveeps/components/atoms/sale-scenario"

export default {
  name: 'rate-details',

  components: {
    'sale-scenario': SaleScenario,
  },

  props: {
    rate: Object
  },

  data() {
    return {
      info: {
        occupancy: null,
        checkin: null,
        checkout: null
      }
    }
  },

  computed: {
    ...mapState({
      // stato globale
      occupancy: state => state.occupancy,

      // stato del modulo liveeps
      checkin: state => state.liveeps.checkin,
      checkout: state => state.liveeps.checkout,
    }),

    ...mapGetters([
      'points_available'
    ]),

    // Struttura dati dettagli room.rate
    details() {
      const { pricing, sale_scenario } = this.rate

      return {
        nights: get_total_nights(this.info.checkin, this.info.checkout),
        occupancy: get_label_occupancy(this.info.occupancy),
        price_nightly: markup(pricing.nightly).live_price,
        sale_scenario: sale_scenario,
      }
    },

  },

  created() {
    this.info.checkin = this.checkin
    this.info.checkout = this.checkout
    this.info.occupancy = deep_clone(this.occupancy)
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .rate-details {
    font-size: $font-size-md;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: $grid-gutter-width / 6;

    span {
      display: flex;
      align-items: center;
      margin-right: $grid-gutter-width / 5;

      &:after {
        content: '';
        width: 4px;
        height: 4px;
        display: inline-block;
        border-radius: $border-radius;
        background-color: $gray-600;
        margin-left: $grid-gutter-width / 5;
      }

      &:last-child {
        margin-right: 0;

        &:after {
          display: none;
        }
      }
    }
  }

</style>